import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { IncludedSection } from './components/IncludedSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalSection } from './components/FinalSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full bg-paper font-sans antialiased" data-id="element-0" data-mp="2mn5f2tci77mi">
      <Hero data-id="element-1" data-mp="31b8j3x6zk98o" />
      <main data-id="element-2" data-mp="31ayplzmqfjy8">
        <ProblemSection data-id="element-3" data-mp="31bibfrfi6shj" />
        <MechanismSection data-id="element-4" data-mp="31c1ksjr388jy" />
        <IncludedSection data-id="element-5" data-mp="2wk0av4he6tx3" />
        <OfferSection data-id="element-6" data-mp="2wjqg73lejyl2" />
        <FaqSection data-id="element-7" data-mp="2wiferaffj2x4" />
        <FinalSection data-id="element-8" data-mp="2whx95n6vnccj" />
      </main>
      <Footer data-id="element-9" data-mp="28tw6guwdqq51" />
      <StickyCta data-id="element-10" data-mp="28tmej1rry8wp" />
    </div>;
}